import { ConfigProviderProps } from 'antd/es/config-provider'
// 国际化失效：https://github.com/ant-design/ant-design/issues/56379
import zhCN from 'antd/es/locale/zh_CN'

export const antdConfig: ConfigProviderProps = {
  button: {
    autoInsertSpace: true
  },
  locale: zhCN,
  modal: {
    mask: {
      blur: false
    }
  },
  drawer: {
    mask: {
      blur: false
    }
  },
  tag: {
    styles: {
      root: {
        marginInlineEnd: 8
      }
    }
  },
  theme: {
    token: {
      fontSize: 14
    },
    components: {
      Layout: {
        headerHeight: 48,
        headerBg: '#fff'
      }
    }
  }
}
